import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href", "href"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    iconName: null
  },
  setup(__props: any) {

const props = __props as {
	iconName: string;
};



const classString = computed(() => `svg-icon icon-${props.iconName}`);
const hrefString = computed(() => `#icon-${props.iconName}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_unref(classString))
  }, [
    _createElementVNode("use", {
      "xlink:href": _unref(hrefString),
      href: _unref(hrefString)
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})